import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-download-cloud-2-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white">
                91<span className="text-primary-400">下载</span>
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              极速安全的软件下载平台，提供海量正版软件、游戏、工具类应用的免费下载服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">软件分类</Link>
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <div className="space-y-2.5">
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">办公软件</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">游戏下载</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">实用工具</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">多媒体</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <div className="space-y-2.5">
              <p className="text-sm text-foreground-400">
                <i className="ri-mail-line mr-2"></i>support@91xiazai.com
              </p>
              <p className="text-sm text-foreground-400">
                <i className="ri-phone-line mr-2"></i>400-888-9191
              </p>
              <p className="text-sm text-foreground-400">
                <i className="ri-map-pin-line mr-2"></i>北京市海淀区中关村软件园
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2025 91下载. 保留所有权利. | <span className="hover:text-foreground-300 cursor-pointer transition-colors">京ICP备2025000001号</span>
            </p>
            <div className="flex items-center gap-4 text-foreground-500 text-sm">
              <span className="hover:text-foreground-300 cursor-pointer transition-colors">隐私政策</span>
              <span className="hover:text-foreground-300 cursor-pointer transition-colors">服务条款</span>
              <span className="hover:text-foreground-300 cursor-pointer transition-colors">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}